/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {setReportTransactionType} from '../../../../common/menu/report/transaction/actions';
import {setReportTransactionVisibleForm} from '../../../../common/menu/report/transaction/actions';
import {showPopupInMenu} from '../../../../common/menu/actions';

class CashBoxPopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        showPopupInMenu: React.PropTypes.func,
        setReportTransactionType: React.PropTypes.func,
        setReportTransactionVisibleForm: React.PropTypes.func,
        transactionTypes: React.PropTypes.object
    };

    selectType(type) {
        const {setReportTransactionVisibleForm, setReportTransactionType, showPopupInMenu} = this.props;
        setReportTransactionType(type);
        setReportTransactionVisibleForm(true);
        showPopupInMenu(false);
    }

    render() {
        const {transactionTypes, msg} = this.props;

        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.transactions.new}</h1>
                <div className="popup-list">
                  <div className="popup-list-key">
                    <div className="boxBtn color-white"
                         onClick={() => this.selectType(transactionTypes.INCOME)}>
                        <div className="boxBtn-inner">
                            <span>
                                {msg.transactions.income}
                            </span>
                        </div>
                    </div>
                  </div>
                  <div className="popup-list-key">
                    <div className="boxBtn color-white"
                         onClick={() => this.selectType(transactionTypes.OUTCOME)}>
                        <div className="boxBtn-inner">
                            <span>
                                {msg.transactions.outcome}
                            </span>
                        </div>
                    </div>
                  </div>
                  <div className="popup-list-key">
                    <div className="boxBtn color-white"
                         onClick={() => this.selectType(transactionTypes.TRANSFER)}>
                        <div className="boxBtn-inner">
                            <span>
                                {msg.transactions.transfer}
                            </span>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    transactionTypes: state.transactions.get('transactionTypes')
}), {setReportTransactionType, setReportTransactionVisibleForm, showPopupInMenu})(CashBoxPopup);



// WEBPACK FOOTER //
// ./src/browser/menu/report/transactions/TypePopup.js